import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Row, Col } from "reactstrap";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import { reactLocalStorage } from "reactjs-localstorage";
import { ApplyPaymentTerms } from ".";
import _ from "lodash";
import ReactExport from "react-export-excel";
import LoaderCustom from "../../common/LoaderCustom";
import NoContentFound from "../../common/NoContentFound";
import { resetStatePagination } from "../../common/Pagination/paginationAction";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import Toaster from "../../common/Toaster";
import { PaginationWrapper } from "../../common/commonPagination";
import { setSelectedRowForPagination } from "../../simulation/actions/Simulation";
import {
  EMPTY_DATA,
  PaymentList,
  defaultPageSize,
} from "../../../config/constants";
import {
  PAYMENT_LIST_EXCEL,
} from "../../../config/masterData";
import { MESSAGES } from "../../../config/message";
import {
  handleDepartmentHeader,
  loggedInUserId,
  searchNocontentFilter,
  setLoremIpsum,
  showTitleForActiveToggle,
  userDetails,
} from "../../../helper";
import {
  activeInactivePaymentMasterList,
  deletePaymentMaster,
  fetchAllPaymentMaster,
} from "./Action";
import AddPaymentTerms from "./Component/AddPaymentTerms";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const PaymentMasterList = (props) => {
  const permissionPaymentTerms = useContext(ApplyPaymentTerms);
  const { PaymentMasterReducer } = useSelector(
    (state) => state?.PaymentMasterReducer
  );
  const datata = useSelector((state) => state);

  const dispatch = useDispatch();
  const [isModalRejectOpen, setIsModalRejectOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [deletedId, setDeletedID] = useState(null);
  const [loader, setloader] = useState(false);
  const [open, setOpen] = useState(false);
  const currentListQty = (PaymentMasterReducer?.page - 1) * 10;
  let serialNumber = currentListQty + 1; // Start numbering from 1
  // const usersWithSerialNumbers = PaymentMasterReducer?.Data;
  const usersWithSerialNumbers = (PaymentMasterReducer?.Data || []).map(
    (user, index) => {
      const updatedSerialNumber = serialNumber + index;
      return {
        ...user,
        serialNumber: updatedSerialNumber,
      };
    }
  );

  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });

  const getUsers = async (currentPage, pageSize, sortOrder, fieldName) => {
    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchAllPaymentMaster({
          current_page: currentPage,
          per_page: pageSize,
          sortOrder: sortOrder,
          sortField: fieldName,
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };
  /**
   * @method onFloatingFilterChanged
   * @description Filter data when user type in searching input
   */
  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (usersWithSerialNumbers.length !== 0) {
        setState((prevState) => ({
          ...prevState,
          noData: searchNocontentFilter(value, prevState.noData),
        }));
      }
    }, 500);
  };

  useEffect(() => {
    // Function to fetch data after a 3-second delay
    const fetchDataWithDelay = async () => {
      // Show loader
      setloader(true);

      // Simulate loading for 3 seconds
      await new Promise((resolve) => setTimeout(resolve, 500));

      try {
        // Fetch data after the delay
        await getUsers(1, defaultPageSize, "ASC");
      } catch (error) {

      } finally {
        // Hide loader after fetching data or encountering an error
        setloader(false);
      }
    };
    // Call fetchDataWithDelay function
    fetchDataWithDelay();
  }, []);
  useEffect(() => {
    reactLocalStorage.setObject("selectedRow", {});
    if (!props.stopApiCallOnCancel) {
      return () => {
        dispatch(setSelectedRowForPagination([]));
        dispatch(resetStatePagination());

        reactLocalStorage.setObject("selectedRow", {});
      };
    }
  }, []);
  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  const onBtExport = () => {
    let tempArr = state.gridApi && state.gridApi.getSelectedRows();
    tempArr =
      tempArr && tempArr.length > 0
        ? tempArr
        : usersWithSerialNumbers
          ? usersWithSerialNumbers
          : [];
    return returnExcelColumn(PAYMENT_LIST_EXCEL, tempArr);
  };
  const resetState = () => {
    const searchBox = document.getElementById("filter-text-box");
    if (searchBox) {
      searchBox.value = "";
    }
    state.gridApi.setQuickFilter(null);
    state.gridApi.deselectAll();
    state.gridApi.setFilterModel(null);
    state.gridColumnApi.resetColumnState();
    setState((prevState) => ({ ...prevState, noData: false }));
  };
  const returnExcelColumn = (data = [], TempData) => {
    return (
      <ExcelSheet data={TempData} name={PaymentList}>
        {data &&
          data.map((ele, index) => (
            <ExcelColumn
              key={index}
              label={
                ele.label === "Company Name"
                  ? `${handleDepartmentHeader()} Name`
                  : ele.label
              }
              value={(col) => {
                if (ele.value === "IsActive") {
                  return col[ele.value] ? "Active" : "Inactive";
                } else {
                  return col[ele.value];
                }
              }}
              style={ele.style}
            />
          ))}
      </ExcelSheet>
    );
  };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onGridReady = (params) => {
    window.screen.width >= 1600 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
  };
  const onPageSizeChanged = (newPageSize) => {
    state.gridApi.paginationSetPageSize(Number(newPageSize));
  };

  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const handleEdit = () => {
      const requestId = props.data?.PaymentTermId;
      // Handle edit action
      // history.push(`/add-business-type?id=${requestId}&mode=edit`);
      setOpen({ open: true, id: requestId,guid: props.data?.ItemGuid });
    };

    const handleDeletePopup = () => {
      setShowPopup(true);
      setDeletedID(props?.data?.ItemGuid);
    };
    return (
      <div>
        {permissionPaymentTerms?.Edit && (
          <button
            title="Edit"
            className="Edit hl-accept-icon mr-2"
            type="button"
            onClick={handleEdit}
          ></button>
        )}
        {permissionPaymentTerms?.Delete && (
          <button
            title="Delete"
            className="Delete hl-delete-icon"
            type="button"
            onClick={handleDeletePopup}
          ></button>
        )}
      </div>
    );
  };
  const statusButtonFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props?.valueFormatted // Fix: Change 'valueFormatted' to 'valueFormatted'
      : props?.value;
    const rowData = props?.valueFormatted
      ? props?.valueFormatted // Fix: Change 'valueFormatted' to 'valueFormatted'
      : props?.data;
    showTitleForActiveToggle(props?.rowIndex, "Active", "Inactive");
    return (
      <>
        <label
          htmlFor="normal-switch"
          className="normal-switch Tour_List_Status"
        >
          <Switch
            onChange={() => handleChange(cellValue, rowData)}
            checked={cellValue}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            offColor="#FC5774"
            id="normal-switch"
            height={24}
            className={cellValue ? "active-switch" : "inactive-switch"}
          />
        </label>
      </>
    );
  };

  const handleChange = (cell, row) => {

    let data = {
      Id: row.PaymentTermId,
      ModifiedBy: loggedInUserId(),
      IsActive: !cell, //Status of the user.
    };
    setState((prevState) => ({
      ...prevState,
      showPopupToggle: true,
      cellData: data,
      cellValue: cell,
    }));
  };
  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    customNoRowsOverlay: NoContentFound,
  };
  const handleDeleteSpecialization = (specializationId) => {
    setloader(true); // Set loader to indicate deletion process
    deletePaymentMaster(specializationId, (error, response) => {
      if (error) {

        Toaster.error(error?.response?.data?.ErrorMessage);
        // Handle the error as needed
      } else {

        Toaster.success(response?.data?.Data?.Message);
        // Fetch updated data after deletion
        getUsers(1, defaultPageSize, "ASC")
          .then(() => {
            setloader(false); // Stop loader after data is fetched
          })
          .catch((error) => {

            // Handle the error if needed
          });
      }
    });
  };

  const onPopupConfirm = () => {
    setShowPopup(false);
    handleDeleteSpecialization(deletedId);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const onRejectConfirm = () => {
    setIsModalRejectOpen(false);
  };

  const onPopupConfirmToggle = () => {
    confirmDeactivateItem(state.cellData, state.cellValue);
  };
  const confirmDeactivateItem = (data, cell) => {

    let empId = userDetails();
    setloader(true);
    const requestData = {
      Id: data?.Id,
      LoggedInEmpId: empId?.EmployeeId,
      IsActive: data.IsActive,
    };
    dispatch(
      activeInactivePaymentMasterList(requestData, (res) => {
        if (res && res?.data?.IsSuccessful) {
          if (cell === true) {
            Toaster.success(res?.data?.FriendlyMessage);
            getUsers(1, defaultPageSize, "ASC");
          } else {
            Toaster.success(res?.data?.FriendlyMessage);
            getUsers(1, defaultPageSize, "ASC");
          }
          // filterList();
          setState((prevState) => ({ ...prevState, dataCount: 0 }));
        }
      })
    );

    setState((prevState) => ({ ...prevState, showPopupToggle: false }));
  };
  const closePopUp = () => {
    setShowPopup(false);
    setState((prevState) => ({ ...prevState, showPopupToggle: false }));
  };
  return (
    <>
      {loader && <LoaderCustom customClass="simulation-Loader" />}
      {showPopup && (
        <PopupMsgWrapper
          isOpen={showPopup}
          closePopUp={closePopUp}
          confirmPopup={onPopupConfirm}
          message={`Are you sure you want to delete this item?`}
        />
      )}

      {isModalRejectOpen && (
        <PopupMsgWrapper
          isOpen={isModalRejectOpen}
          closePopUp={closePopUp}
          confirmPopup={onRejectConfirm}
          message={`Are you sure you want to reject this application?`}
        />
      )}
      <>
        <Row className="ag-grid-react without-filter-grid">
          <Col>
            <div>
              <div
                className={`ag-theme-material ${loader && "max-loader-height"}`}
              >
                <Row className={`filter-row-large`}>
                  <Col md="12" className="mb-3 d-flex justify-content-end">
                    <div className="d-flex justify-content-end bd-highlight w100">
                      <>
                        {permissionPaymentTerms?.Add && (
                          <button
                            className="user-btn mr5"
                            title="Add"
                            onClick={() => {
                              setOpen(true);
                            }}
                          >
                            <div className={"plus mr-0"}></div>
                          </button>
                        )}
                        <>
                          {permissionPaymentTerms?.Download && (
                            <ExcelFile
                              filename={PaymentList}
                              fileExtension={".xls"}
                              element={
                                <button
                                  title={`Download ${state.dataCount === 0
                                      ? "All"
                                      : "(" + state.dataCount + ")"
                                    }`}
                                  type="button"
                                  className={"user-btn mr5 Tour_List_Download"}
                                >
                                  <div className="download mr-1"></div>
                                  {`${state.dataCount === 0
                                      ? "All"
                                      : "(" + state.dataCount + ")"
                                    }`}
                                </button>
                              }
                            >
                              {onBtExport()}
                            </ExcelFile>
                          )}
                        </>
                        <button type="button" className="user-btn Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                          <div className="refresh mr-0"></div>
                        </button>
                      </>
                    </div>
                  </Col>
                </Row>
                <div
                  className={`ag-grid-wrapper height-width-wrapper ${(usersWithSerialNumbers &&
                      usersWithSerialNumbers?.length <= 0) ||
                      state.noData
                      ? "overlay-contain"
                      : ""
                    }`}
                >
                  <div
                    className={`ag-theme-material ${state.isLoader && "max-loader-height"
                      }`}
                  >
                    {state.noData && (
                      <NoContentFound
                        title={EMPTY_DATA}
                        customClassName="no-content-found"
                      />
                    )}
                    {state.isLoader ? (
                      <LoaderCustom customClass="loader-center" />
                    ) : (
                      <AgGridReact
                        defaultColDef={defaultColDef}
                        floatingFilter={true}
                        domLayout="autoHeight"
                        // columnDefs={c}
                        rowData={
                          state.showExtraData && usersWithSerialNumbers
                            ? [
                              ...setLoremIpsum(usersWithSerialNumbers[0]),
                              ...usersWithSerialNumbers,
                            ]
                            : usersWithSerialNumbers
                        }
                        pagination={true}
                        paginationPageSize={defaultPageSize}
                        onGridReady={onGridReady}
                        gridOptions={gridOptions}
                        noRowsOverlayComponent={"customNoRowsOverlay"}
                        noRowsOverlayComponentParams={{
                          title: EMPTY_DATA,
                          imagClass: "imagClass",
                        }}
                        rowSelection={"multiple"}
                        suppressRowClickSelection={true}
                        onSelectionChanged={onRowSelect}
                        onFilterModified={onFloatingFilterChanged}
                        frameworkComponents={frameworkComponents}
                      >
                        <AgGridColumn
                          cellClass="has-checkbox"
                          field="Code"
                          floatingFilter={true}
                          // comparator={(
                          //   valueA,
                          //   valueB,
                          //   nodeA,
                          //   nodeB,
                          //   isInverted
                          // ) =>
                          //   valueA
                          //     .toLowerCase()
                          //     .localeCompare(valueB.toLowerCase())
                          // }
                          headerName="Payment Code"
                        ></AgGridColumn>

                        <AgGridColumn
                          field="Name"
                          floatingFilter={true}
                          headerName="Payment Name"
                        ></AgGridColumn>
                        <AgGridColumn
                          width="150"
                          field="IsActive"
                          headerName="Status"
                          floatingFilter={false}
                          cellRenderer={"statusButtonFormatter"}
                        ></AgGridColumn>
                        <AgGridColumn
                          width="150"
                          headerName="Action"
                          sortable={false}
                          cellRenderer={"totalValueRenderer"}
                          type="rightAligned"
                          floatingFilter={false}
                        ></AgGridColumn>
                      </AgGridReact>
                    )}
                    {
                      <PaginationWrapper
                        gridApi={state.gridApi}
                        setPage={onPageSizeChanged}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </>
      {state.showPopupToggle && (
        <PopupMsgWrapper
          isOpen={state.showPopupToggle}
          closePopUp={closePopUp}
          confirmPopup={onPopupConfirmToggle}
          message={`${state.cellValue
              ? MESSAGES.VENDOR_DEACTIVE_ALERT
              : MESSAGES.VENDOR_ACTIVE_ALERT
            }`}
        />
      )}
      <AddPaymentTerms
        closeDrawer={closeDrawer}
        setOpen={setOpen}
        open={open}
      />
    </>
  );
};

export default PaymentMasterList;
